/**
 * Navigation Service for handling programmatic navigation
 * This provides a bridge between React Router and non-component code (epics, actions, etc.)
 */

type NavigateFunction = (to: string, options?: { replace?: boolean }) => void;

class NavigationService {
  private navigateFn: NavigateFunction | null = null;

  /**
   * Set the navigate function (should be called from App component)
   */
  setNavigate(navigateFn: NavigateFunction) {
    this.navigateFn = navigateFn;
  }

  /**
   * Navigate to a route
   */
  navigate(to: string, options?: { replace?: boolean }) {
    if (this.navigateFn) {
      this.navigateFn(to, options);
    } else {
      console.warn('NavigationService: navigate function not set. Make sure to call setNavigate() in your App component.');
      // Fallback to window.location for critical navigation
      if (options?.replace) {
        window.location.replace(to);
      } else {
        window.location.href = to;
      }
    }
  }

  /**
   * Replace current route
   */
  replace(to: string) {
    this.navigate(to, { replace: true });
  }

  /**
   * Legacy AppHistory.push replacement
   */
  push(to: string) {
    this.navigate(to);
  }
}

// Export singleton instance
export const navigationService = new NavigationService();
export default navigationService;